import styled from "styled-components"

import { ButtonNew } from "components/form/ButtonNew"
import { InputNew } from "components/form/InputNew"
import { InputPhone } from "components/form/InputPhone"

export const Sidebar = styled.aside<{ isOpen: boolean }>`
  position: absolute;
  right: ${({ isOpen }) => (isOpen ? "0" : "-325px")};
  top: 0;
  width: 300px;
  height: 100%;
  background: var(--surface-1);
  border-left: 1px solid var(--border-default);
  transition: right 0.3s ease;
  z-index: 1000;
  display: flex;
  flex-direction: column;
`

export const SidebarContent = styled.div`
  flex: 1;
  overflow-y: auto;
`

export const SidebarFooter = styled.div`
  margin-top: auto;
  padding: 16px 0;
  border-top: 1px solid var(--border-default);
  display: flex;
  justify-content: flex-end;
`

export const StyledButtonNew = styled(ButtonNew)`
  height: 32px !important;
`

export const SidebarHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 13px 0 13px 16px;
  border-bottom: 1px solid var(--border-default);
`

export const SidebarTitle = styled.h3`
  font-size: 18px;
  font-weight: 500;
  color: var(--text-primary);
  margin: 0;
`

export const CloseButton = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  padding: 4px;
  display: flex;
  align-items: center;
  justify-content: center;

  svg {
    width: 20px;
    height: 20px;
    fill: #64748b;
  }

  &:hover svg {
    fill: #0f172a;
  }
`

export const FieldRow = styled.div`
  display: flex;
  gap: 10px;
  justify-content: flex-start;
`

export const FieldItem = styled.div`
  flex: 1;
  min-width: 100px;
  padding: 0 15px 20px;
`

export const FieldWrapper = styled.div`
  display: flex;
  flex-direction: column;
`

export const FieldLabel = styled.h4`
  font-size: 14px;
  color: var(--text-muted);
  margin: 0 0 4px 0;
  font-weight: 300;
`

export const ReadOnlyValue = styled.div`
  font-size: 14px;
  font-weight: 500;
  color: var(--text-disabled);
  padding: 10px 0 0 10px;
`

export const MobileAppContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: var(--surface-2);
  border-radius: 8px;
  padding: 12px 16px;
`

export const MobileAppLabel = styled.span`
  font-size: 14px;
  color: var(--text-muted);
  font-weight: 300;
`

export const MobileAppValue = styled.span`
  font-size: 16px;
  color: var(--text-primary);
  font-weight: 400;
`

export const StyledInputNew = styled(InputNew)`
  div {
    max-width: 100%;
  }
`

export const StyledInputPhone = styled(InputPhone)`
  div {
    max-width: 100%;
  }
`
